const toDay = (value: Date | string) => {
  const date = value instanceof Date ? value : new Date(value);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

/**
 * Даты турнира для показа. Турнир обычно идёт один день — тогда выводим одну дату,
 * а у старых многодневных турниров — диапазон «начало – окончание».
 */
export function formatTournamentDates(
  startDate?: Date | string,
  endDate?: Date | string,
  locale: string = 'ru-RU'
): string {
  if (!startDate) return '';
  const start = toDay(startDate);
  const startText = start.toLocaleDateString(locale);
  if (!endDate) return startText;

  const end = toDay(endDate);
  if (end.getTime() <= start.getTime()) return startText;
  return `${startText} – ${end.toLocaleDateString(locale)}`;
}
